import React, { Component } from 'react';
import { connect } from 'react-redux';
import { uploadImg } from '../../store/actions/authActions';
import CustomUploadButton from 'react-firebase-file-uploader/lib/CustomUploadButton';
import firebase from "firebase";
import { NavLink } from 'react-router-dom';

import profilePlaceholder from '../../no-profile.png';

import * as ROUTES from '../../constants/routes';

class ProfilePanel extends Component {
    constructor(props) {
        super();
    }

    state = {
        avatar: "",
        isUploading: false,
        progress: 0,
        avatarURL: ""
    }

    handleSubmit = (e) => {
        e.preventDefault();

        this.props.uploadImg(this.state);

        console.log(this.state);
    }

    handleUploadSuccess = filename => {

        this.setState({ avatar: filename, progress: 100, isUploading: false });
        firebase
        .storage()
        .ref("images")
        .child(filename)
        .getDownloadURL()
        .then(url => this.setState({ avatarURL: url }));
    };

    render() {

        const { profile, auth } = this.props;

        const profileImg =   
        <div style={{ paddingBottom: 0, marginBottom: 0 }}>              
            <img 
                src={profile.avatarURL}
                alt={profile.ceoNAME} 
                style={{ width: "100%"}}
                className="img-thumbnail"
            />
        </div>

        const uploadImg =                 
            <div style={{ paddingTop: 0, marginBottom: 0 }}>
                <img src={profilePlaceholder} alt="no-profile" className="img-thumbnail" style={profilePicStyle} />
                <form onSubmit={this.handleSubmit} className="form-group">

                    {this.state.isUploading && <p>Progress: {this.state.progress}</p>}
                    {this.state.avatarURL && <img src={this.state.avatarURL} alt="uploaded" style={{ maxWidth: "150px", maxHeight: "150px" }} />}
                    {!this.state.avatarURL && 
                        <CustomUploadButton
                            accept="image/*"
                            storageRef={firebase.storage().ref('images')}
                            onUploadStart={this.handleUploadStart}
                            onUploadError={this.handleUploadError}
                            onUploadSuccess={this.handleUploadSuccess}
                            onProgress={this.handleProgress}
                            style={{backgroundColor: 'steelblue', color: 'white', padding: 10, borderRadius: 4}}
                            >
                            Upload profile picture
                        </CustomUploadButton>
                            }
                    {this.state.avatarURL && 
                        <button className="btn btn-primary btn-block btn-custom" >Upload</button>
                    }
                </form>
            </div>

        return (
            <div className="profile-panel">
                <div className="card">
                    {profile.avatarURL ? profileImg : uploadImg} 
                    <div style={{ margin: 0, padding: "10px 0 0 0" }}>
                            <p className="title">{profile.companyName}</p>
                    </div>
                    <p className="subtitle">Owned by {profile.ceoNAME}</p>
                    <p className="subtitle font-italic">{profile.companyDescription}</p>
                    <a href={profile.website} target="_blank" rel="noopener noreferrer"><i className="fa fa-dribbble"></i></a>
                    <a href={profile.twitter} target="_blank" rel="noopener noreferrer"><i className="fa fa-twitter"></i></a>
                    <a href={profile.linkedin} target="_blank" rel="noopener noreferrer"><i className="fa fa-linkedin"></i></a>
                    <a href={profile.facebook} target="_blank" rel="noopener noreferrer"><i className="fa fa-facebook"></i></a>
                    <br />
                    <NavLink to={'/users/' + auth.uid}><p><button>Profile</button></p></NavLink>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        auth: state.firebase.auth,
        profile: state.firebase.profile,
        authError: state.auth.authError
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        uploadImg: (user) => dispatch(uploadImg(user)) 
    }
}

const profilePicStyle = {
    width: "100%"
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePanel);